"use strict";
'app public';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  data() {
    return {
      accepted: false,
      scrolledToBottom: false,
      // Date de « Dernière mise à jour » des CGU — SOURCE UNIQUE : affichée dans
      // l'en-tête ET envoyée au journal d'acceptation côté serveur (cf. onEnter).
      // Mettre à jour ici lorsqu'on modifie le texte des CGU.
      cguDate: '01 juillet 2026'
    };
  },
  computed: {
    canEnter() {
      return this.scrolledToBottom && this.accepted;
    }
  },
  mounted() {
    // Si le texte tient sans défilement (grand écran), on considère la lecture
    // faite d'emblée pour ne pas bloquer inutilement.
    this.$nextTick(this.checkScrollable);
  },
  methods: {
    checkScrollable() {
      let el = this.$refs.scroll;
      if (el && el.scrollHeight - el.clientHeight <= 4) {
        this.scrolledToBottom = true;
      }
    },
    onScroll() {
      let el = this.$refs.scroll;
      if (!el) {
        return;
      }
      // Bas atteint (marge de 8px) → on déverrouille définitivement (pas de
      // retour arrière si l'utilisateur remonte).
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 8) {
        this.scrolledToBottom = true;
      }
    },
    onEnter() {
      if (!this.canEnter) {
        return;
      }
      // Journalise l'acceptation côté serveur AVANT d'entrer (best-effort).
      this.logAcceptance();
      this.$emit('accept');
    },
    // Envoie « pseudo + date CGU » à l'endpoint serveur, qui journalise la ligne
    // « Pseudo - IP - CGU date » (l'IP est lue CÔTÉ SERVEUR, le client ne l'a pas).
    // Best-effort : une erreur réseau ne doit JAMAIS bloquer l'entrée dans le tchat.
    // Endpoint PHP à déployer sur CHAQUE site : cf. server/log-cgu.php (README §13).
    logAcceptance() {
      try {
        let host = window.location.hostname;
        // Pas de log en dev (localhost) : aucun backend.
        if (host === 'localhost' || host === '127.0.0.1') {
          return;
        }
        // Hôte du log-cgu.php par site : l'app tourne sur app.<site>, le PHP est
        // déployé sur le site correspondant. La correspondance n'est PAS uniforme
        // (gayzou utilise www, caramail non) → table explicite. ► AJOUTER un site
        // ICI. Repli pour un site non listé : on retire simplement « app. ».
        let logHosts = {
          'app.gayzou.fr': 'www.gayzou.fr',
          'app.chat-caramail.fr': 'chat-caramail.fr',
          'app.chatiz.fr': 'chatiz.fr'
        };
        let logHost = logHosts[host] || host.replace(/^app\./, '');
        let url = window.location.protocol + '//' + logHost + '/log-cgu.php';
        let net = this.$state.getActiveNetwork();
        let nick = net && net.nick || '';
        let body = 'nick=' + encodeURIComponent(nick) + '&cgu_date=' + encodeURIComponent(this.cguDate);
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body,
          keepalive: true
        }).catch(() => {/* best-effort : log non bloquant */});
      } catch (e) {/* best-effort */}
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["CguModal"]
window._app_exports.components.CguModal = exports.default ? exports.default : exports;
